module.exports = __webpack_public_path__ + "static/media/gloomy-sad.b316b45e.png";